import React from 'react';
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';

import LogisticTaskBll from '../../../entities/logistic/logisticTasks/LogisticTaskBll/LogisticTaskBll';
import PetrolDeliveryMainPanelBll from './PetrolDeliveryMainPanelBll';
import Container from './styles/Container';
import Wrapper from './styles/Wrapper';
import LogisticTaskActionButtons from '../../../features/logistics/LogiscticTaskActionButtons/LogiscticTaskActionButtons';
import HeadWrapper from './styles/HeadWrapper';

function PetrolDeliveryMainPanel() {
  const params = useParams();
  const logisticTaskId = parseInt(params.logisticTaskId, 10);

  return (
    <Container>
      <HeadWrapper>
        <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary' }}>
          Построение маршрутов для перевозки нефтепродуктов
        </Typography>
        <LogisticTaskBll logisticTaskId={logisticTaskId}>
          <LogisticTaskActionButtons />
        </LogisticTaskBll>
      </HeadWrapper>
      <Wrapper>
        <LogisticTaskBll logisticTaskId={logisticTaskId}>
          <PetrolDeliveryMainPanelBll />
        </LogisticTaskBll>
      </Wrapper>
    </Container>
  );
}

export default PetrolDeliveryMainPanel;
